module.exports = __webpack_public_path__ + "media/images/version_merge/photostep_trash/like_this_cmnd_front-ed3e59289fbaaddc9efffa60308894cc.jpg";